import {createAsyncThunk} from '@reduxjs/toolkit'
import * as types from './types'
import {filterSuccess, filterFail} from './operations'
import digipayLocationService from 'app/modules/core/digipayLocationService'
import normalize from 'app/modules/core/normalize'
import {v4 as uuidv4} from 'uuid'

export const filterRequest = createAsyncThunk(
  types.FILTER_REQUEST,
  async (distance, { getState, dispatch }) => {
    const {token} = getState().branchesData.lookupData

    digipayLocationService.get(`lookups/${token}/locations?distance=${distance}`)
      .then(response => {
        const lookupData = {
          ...response.data,
          locations: normalize(response.data.locations.map(location => ({
            ...location,
            id: uuidv4(),
            coordinates: [location.coordinates.longitude, location.coordinates.latitude],
          })), 'id')
        }

        dispatch(filterSuccess(lookupData))
      }).catch(error => {
        console.log(error)
        dispatch(filterFail())
      })
  }
)